import MyExpApi from "apps/myExperience/enum/MyExpApi";
import ParticipantSubRole from "shared/enums/ParticipantSubRole";
import { useQueryClient } from "react-query";
import { ApiRegistrationParticipantForManagement } from "shared/types/ApiRegistrationParticipantForManagement";
import { useCopies } from "shared/hooks/useCopies";
import { successToast } from "shared/utils/toastNotification";
import { getApiQueryKey, useGetApiData, usePostApiData } from "shared/datalayer";
import ApiRemoveOrgAdminRequest from "shared/types/ApiRemoveOrgAdminRequest";

export function getParticipantListForManagementKey(regParticipantId?: string) {
  return getApiQueryKey(MyExpApi.GET_PARTICIPANT_LIST_FOR_MANAGEMENT, {
    params: { id: regParticipantId, participantSubRole: ParticipantSubRole.ORGANIZATION_ADMIN }
  });
}

export function useGetParticipantListForManagement({ regParticipantId }: { regParticipantId?: string }) {
  return useGetApiData<Array<ApiRegistrationParticipantForManagement>>(
    MyExpApi.GET_PARTICIPANT_LIST_FOR_MANAGEMENT,
    {
      params: { id: regParticipantId, participantSubRole: ParticipantSubRole.ORGANIZATION_ADMIN }
    },
    {
      enabled: Boolean(regParticipantId)
    }
  );
}

export function useRevokeOrgAdmin({ regParticipantId }: { regParticipantId?: string }) {
  const copies = useCopies();
  const queryClient = useQueryClient();
  return usePostApiData<any, ApiRemoveOrgAdminRequest>(MyExpApi.REVOKE_ORG_ADMIN, {
    onSuccess: () => {
      queryClient.invalidateQueries(getParticipantListForManagementKey(regParticipantId));
      successToast(copies.get("org.admin.role.revoked"));
    },
    onError: error => {
      if (error?.response?.data?.refreshPage)
        queryClient.invalidateQueries(getParticipantListForManagementKey(regParticipantId));
    }
  });
}
